<div class="flex flex-col gap-2">
    <div class="flex items-center gap-2">
        <ng-template [ngIf]="!control" [ngIfElse]="reactiveFormField">
            <input
                type="checkbox"
                [name]="config?.name ?? ''"
                [id]="config?.id ?? ''"
                [disabled]="disabled"
                [(ngModel)]="value"
                (ngModelChange)="onChangeListener($event)"
                class="zt-toggle-input"
            />
        </ng-template>
        <ng-template #reactiveFormField>
            <input
                type="checkbox"
                [name]="config?.name ?? ''"
                [id]="config?.id ?? ''"
                [formControl]="control"
                class="zt-toggle-input"
            />
        </ng-template>
        <label *ngIf="config?.label" [for]="config?.id" class="zt-toggle-label">
            {{ config?.label }}
        </label>
    </div>
</div>
